import PageTitle from "../components/PageTitle";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApiCall from "../common/ApiCall";
import Index from "../view/BlogDetail/Index";
import helper, { getLangBySlug, getSlugByLang, getSlugNameByLang } from "../common/Helper";
import HomeIcon from "../components/Iocns/HomeIcon";
import { setLanguage } from "../redux/user/user.action";
import { useDispatch, useSelector } from "react-redux";

export default function BlogDetailController() {
    const [blogDetail, setBlogDetail] = useState(null)
    const perems = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate()
    const [breadcrumbList, setBreadcrumbList] = useState([])
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    // const slugLang = getSlugByLang(user?.language)
    const [slugLang, setSlugLang] = useState(getSlugByLang(user?.language))

    const getRecordDetails = async (slug) => {
        setIsLoading(true)
        var slugField = "";
        let lang = getLangBySlug(perems?.lang)
        slugField = getSlugNameByLang(lang)
        if (user?.language != lang) {
            dispatch(setLanguage(lang))
        }
        let data = {}
        data.slug = slug
        data.field = slugField
        const fetchrecordDetail = await ApiCall('post', 'blog-detail', data)
        setIsLoading(false)
        if (fetchrecordDetail) {
            if (fetchrecordDetail?.data?.success) {
                setBlogDetail(fetchrecordDetail?.data?.data?.details)
                setBreadcrumbList([
                    {
                        name: <HomeIcon />,
                        url: "/" + slugLang
                    },
                    {
                        name: "Blog",
                        url: ('/' + slugLang) + '/blog'
                    },
                    {
                        name: "Category",
                        url: ('/' + slugLang) + '/blog/category'
                    },
                    {
                        name: fetchrecordDetail?.data?.data?.details?.category?.name,
                        url: ('/' + slugLang) + "/blog/category/" + fetchrecordDetail?.data?.data?.details?.category?.slug,
                    },
                    {
                        name: fetchrecordDetail?.data?.data?.details?.name,
                    },
                ])
            } else {
                navigate(('/' + slugLang) + '/blog')
            }
        }
    };

    useEffect(() => {
        (async () => {
            if (perems?.slug) {
                await getRecordDetails(perems?.slug)
            }
        })();
    }, [perems?.slug]);

    useEffect(() => {
        let sl = getSlugByLang(user?.language)
        setSlugLang(sl)
        setBreadcrumbList([
            {
                name: <HomeIcon />,
                url: "/" + sl
            },
            {
                name: "Blog",
                url: ('/' + sl) + '/blog'
            },
            {
                name: "Category",
                url: ('/' + sl) + '/blog/category'
            },
            {
                name: blogDetail?.category?.name,
                url: ('/' + sl) + "/blog/category/" + blogDetail?.category?.slug,
            },
            {
                name: blogDetail?.name,
            },
        ])
    }, [user?.language]);

    useEffect(() => {

        if (user?.language != "Other") {


            const slugField = getSlugNameByLang(user?.language)
            const slugLang = getSlugByLang(user?.language)

            if (slugField && blogDetail?.[slugField]) {
                window.history.replaceState(null, "", (slugLang ? ('/' + slugLang) : '') + '/blog/article/' + blogDetail?.[slugField]);
            }
        }

        return () => {
            console.log('cleanup');
        };

    }, [user?.language, blogDetail]);

    // console.log(blogDetail?.meta_title);

    return (
        <>
            <PageTitle
                title={blogDetail?.meta_title ?? undefined}
                metaTitle={blogDetail?.meta_title ?? undefined}
                metaKeyword={blogDetail?.meta_keyword ?? undefined}
                metaDescription={blogDetail?.meta_description ?? undefined}
                image={helper.S3Url + '/' + helper.blogImageDir + '/' + blogDetail?.image}
            />
            <Index
                isLoading={isLoading}
                blogDetail={blogDetail}
                breadcrumbList={breadcrumbList}
            />
        </>
    )

}